<p-toast></p-toast>

<div *ngIf="invites().length > 0" class="invites-accent">
  <div class="invites-accent__title">
    <span>Einladungen</span>
    <span class="invites-accent__count">· {{ invites().length }} offen</span>
  </div>

  <div *ngFor="let invite of invites()" class="invites-accent__card">
    <span class="invites-accent__text">{{ invite.text }}</span>

    <div class="invites-accent__actions">

      <p-button label="Akzeptieren"
                size="small"
                (onClick)="acceptInvite(invite)"></p-button>
    </div>
  </div>
</div>
